__turbopack_context__.v({
  "circleButton": "ShareMenuButton-module__dF2inq__circleButton",
  "favorited": "ShareMenuButton-module__dF2inq__favorited",
  "icon": "ShareMenuButton-module__dF2inq__icon",
  "menu": "ShareMenuButton-module__dF2inq__menu",
  "menuDown": "ShareMenuButton-module__dF2inq__menuDown",
  "menuLeft": "ShareMenuButton-module__dF2inq__menuLeft",
  "menuRight": "ShareMenuButton-module__dF2inq__menuRight",
  "menuUp": "ShareMenuButton-module__dF2inq__menuUp",
  "overlay": "ShareMenuButton-module__dF2inq__overlay",
  "playlistMenu": "ShareMenuButton-module__dF2inq__playlistMenu",
  "scrollArea": "ShareMenuButton-module__dF2inq__scrollArea",
  "wrapper": "ShareMenuButton-module__dF2inq__wrapper",
});
